import React, { useCallback } from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { billing, UpgradeSource } from 'common/billing'
import { Ability } from 'common/core/constants/Ability'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

const ARTICLE_LINK = 'https://manychat.com/blog/manychat-pricing-is-changing/'

export const Discount90DaysNotification = () => {
  useDidMountEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.DISCOUNT_90_DAYS.SHOWN')
  })

  const handleRequestUpgradeClick = useCallback(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.DISCOUNT_90_DAYS.ACTIVATE_PRO_TRIAL.CLICKED')
    billing.requestUpgrade({
      source: UpgradeSource.NOTIFICATION_BAR_DISCOUNT_90_DAYS,
      abilities: [Ability.PAID_AUTOMATIONS],
    })
  }, [])

  const handleOpenPricingClick = () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.DISCOUNT_90_DAYS.PRICING.CLICKED')
    window.open(ARTICLE_LINK, '_blank')
  }

  return (
    <>
      <span>
        {l.translate('Don’t miss out on 3 months of Essential for free! Limited time offer.')}
      </span>
      <BtnV2 variant="success" onClick={handleRequestUpgradeClick} className="m-l-sm">
        {l.translate('Try 3 months for free')}
      </BtnV2>
      <a onClick={handleOpenPricingClick} className={cx(cm.viewPricing, 'm-l-sm')}>
        {l.translate('Learn more')}
      </a>
    </>
  )
}
